// extracted by mini-css-extract-plugin
module.exports = {"caption":"EstablishedArtistCaption_caption__V_Xl_","establishedArtistIcon":"EstablishedArtistCaption_establishedArtistIcon__IUwjR"};